import { render } from "./PledgeManagerInfoWhyUs.vue?vue&type=template&id=40f5b8ee"
import script from "./PledgeManagerInfoWhyUs.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoWhyUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__